<template>

  <table
      class="table b-table b-table-stacked-xs table-bordered table-sm bg-white text-uppercase"
  >
    <tbody>
    <tr>
      <th colspan="4">
        <h5 class="text-center"><b>Atendimentos</b></h5>
      </th>
    </tr>
    <tr>
      <td colspan="4">
        <load mode="table"
              v-if="loadingAtendimentos"/>
        <div class="col-md-12"
             v-else>

          <b-table
              :fields="[
                {
                  key: 'protocolo',
                  label: $t('Detalhes'),
                },
                {
                  key: 'created_at',
                  label: $t('Data'),
                },
          ]"
              :items="AtendimentosList"
              :responsive="true"
              striped
              hover
              show-empty
              small
              outlined
              stacked="xs"
              table-class="mb-3"
          >
            <template v-slot:cell(protocolo)="data">
              Usuário(s):<br/>
              <ul>
                <li
                    v-for="pessoa in data.item.usuarios"
                    :key="pessoa.id"
                >
                  <b>{{ pessoa.nome_completo }}</b>
                </li>
              </ul>
              Protocolo: <b>{{ data.item.protocolo }}</b>
              <br/>
              Tipo: <b>{{ data.item.tipo.descricao }}</b>
              <br/>
              Unidade:
              <b>{{
                  data.item.unidade ? data.item.unidade.nome : ""
                }}</b>

            </template>


            <template v-slot:empty="scope">
              <div class="text-center my-5">
                <img
                    :alt="$t('No results')"
                    class="mb-5"
                    src="/img/icons/robot.svg"
                    style="max-height: 165px"
                />
                <h3 class="bold">
                  {{ $t("No records found") }}
                </h3>
              </div>
            </template>
          </b-table>
        </div>
      </td>
    </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: "Atendimentos",
  props: ['familia'],
  data() {
    return {
      AtendimentosList: [],
      loadingAtendimentos: true,
    }
  },
  mounted() {
    this.getAtendimentos();
  },
  methods: {
    getAtendimentos() {

      this.loadingAtendimentos = true;
      axios
          .get(`api/dashboard/print/usuarios/atendimentos/${this.familia}`)
          .then((response) => {
            this.AtendimentosList = response.data.data;
            this.loadingAtendimentos = false;
          })
          .catch(() => {
            this.loadingAtendimentos = false;
          });
    },

  },
}
</script>

<style scoped>

</style>